import React from 'react';
import './WorkDetailsOverview.css';
import data from '../data.json';

const WorkDetailsOverview = ({companydescription, companyjob, start, end, company, tasks, team}) => {
    const stats = [
        { title: 'TASKS', value: tasks.join(', ') },
        { title: 'DURATION', value: `${start} - ${end}` },
        { title: 'COMPANY', value: company },
        { title: 'TEAM', value: team.join(', ') } 
    ];

    return (
        <div className="work-details-overview">
            <div className="overview-text-container">
                <h2 className="overview-title">Overview</h2>
                <p className="overview-paragraph">{companydescription}</p>
                <p className="overview-paragraph">{companyjob}</p>
            </div>
            <div className="stats-container">
                {stats.map((stat, index) => (
                    <div key={index} className="stat-box">
                        <h3 className="stat-title">{stat.title}</h3>
                        <p className="stat-value">{stat.value}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default WorkDetailsOverview;
